import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteUser = (token, id) => {
    return fetch(`${apiUrl}users/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default deleteUser